import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { Encounter } from 'app/core/interfaces/encounter';
import { BaseComponent } from 'app/modules/shared/components/base.component';

@Component({
  selector: 'src-confirm-convenio',
  templateUrl: './confirm-convenio.component.html',
  styleUrls: ['./confirm-convenio.component.css']
})
export class ConfirmConvenioComponent  extends BaseComponent implements OnInit {

  paymentForm: FormGroup;
  public encounter !: Encounter
  public submitted: Boolean = false
  public success: Boolean = false

  constructor(
    injector: Injector, 
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private encounterService: EncounterService
  ) {
    super(injector)
    this.paymentForm = this.fb.group({
      approve: [false],
      reject: [false],
      amount: [{ value: 0, disabled: true }],
    });
  }

  ngOnInit(): void {
    // Monitorar o estado do checkbox "approve"

    this.encounter = this.data.param.encounter

    this.paymentForm.get('approve')?.valueChanges.subscribe((isApproved: boolean) => {
      if (isApproved) {
        this.paymentForm.get('reject')?.setValue(false); // Desmarcar "Reprovar"
        this.paymentForm.get('amount')?.enable();

         const value_to_paid: number =  Number(this.encounter.value) *  (Number(this.encounter.health_plan.discount_rate) / 100)
         this.paymentForm.get('amount')?.reset()
         this.paymentForm.get('amount')?.setValue(value_to_paid)


      } else {
        this.paymentForm.get('amount')?.disable();
        this.paymentForm.get('amount')?.setValue(0);
      }
    });

    // Monitorar o estado do checkbox "reject"
    this.paymentForm.get('reject')?.valueChanges.subscribe((isRejected: boolean) => {
      if (isRejected) {
        this.paymentForm.get('approve')?.setValue(false); // Desmarcar "Aprovar"
        this.paymentForm.get('amount')?.disable();
        this.paymentForm.get('amount')?.setValue(0);
      }
    });
  }

  onSubmit(): void {
    if (this.paymentForm.valid) {
      console.log('Formulário enviado:', this.paymentForm.value);
    }

    const data = {
      agreement_approved: this.paymentForm.value.approve,
      value_agreement: this.paymentForm.value.amount
    }

    console.log(data)

    this.encounterService.confirmEncounterConvenio(this.encounter.encounter_id!, data)
      .subscribe({
        next: (encounter: Encounter) => {
          this.submitted = true
          this.success = true
        },
        error: (err) => {
          this.submitted = true
          this.success = false
          console.log(err)
        }
      })
  }

}
